import React, { Children } from 'react';
import { withStyles,makeStyles } from '@material-ui/core/styles';
import { LinearProgress } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import Button from 'codeArt/components/Button';
import clsx from 'clsx';
import CircularProgress from '@material-ui/core/CircularProgress';
import {getThemeColorValue} from '../components/Base';
import PropTypes from "prop-types";
import Aux from "util/Auxiliary";
import { Alert } from 'reactstrap';
import { Request, Util, Notification } from '../common';
import { Message } from 'codeArt/components/Modal';

const useStyles = makeStyles({
  root: props => ({
    borderRadius:props.height/2,
    height:props.height,
    width:props.width||'auto',
    maxWidth:props.maxWidth||'auto',
    backgroundColor:props.background,
    '& div.MuiLinearProgress-bar':{
      backgroundColor: props.gradient ?  null :props.foreground, 
      background: props.gradient ? `linear-gradient(to right,${props.gradient.start},${props.gradient.end})` : null
    }
  })
});


function _LinearProgress(props) {
  const classes = useStyles(props);
  var p = {...props};
  let className = p.className;
  delete p.foreground;delete p.background;delete p.height;delete p.width;delete p.maxWidth;delete p.className;
  return <LinearProgress className={`${classes.root} ${className}`} {...p}></LinearProgress>;
}

export class ProgressBar extends React.Component {
  
  render() {
    let {value,foreground,gradient,background,height,width,maxWidth,className} = this.props;
    return (
        <_LinearProgress gradient={gradient} className={className} foreground={foreground} background={background} height={height} width={width} maxWidth={maxWidth} variant="determinate" value={value}/>
    );
  }
}

ProgressBar.defaultProps = {
  foreground:"#34bfa3",
  background:"#e9ecef",
  height:6,
  className:''
}




const circularTextUseStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  text: {
    display: 'flex',
    alignItems: 'center',
    justifyContent:'center'
  },
  bgProgress: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1,
    color:"#eee"
  },
  Progress:props=> {
    return {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 2,
      color:props.color
    }
  }
}));

export default function CircularText(props) {
  let p = {...CircularText.defaultProps,...props};
  let {size,value,children,labelClassName,color} = p;
  const classes = circularTextUseStyles({color:getThemeColorValue(color)});

  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <div className={`${classes.text} ${labelClassName}`} style={{width:size,height:size}}>{children}</div>
        <CircularProgress size={size} className={classes.bgProgress} variant="static" value={100} />
        <CircularProgress size={size} className={classes.Progress} variant="static" value={value} />
      </div>
    </div>
  );
}

CircularText.defaultProps={
  value:20,
  size:60,
  label:'',
  color:"success",
  labelClassName:'c-text-s2'
}



export const LineIndicator = ({ title, increase, ratio, width, value, className,bgClassName,titleClassName,spanClassName }) => {
  return (
    <Aux>
      <div className={`d-flex flex-row align-items-center ${className}`}>
        {title ? <p className={`c-text-s1 mb-0 ${titleClassName}`}>{title}</p> : null}
        {increase ? <h5 className={`my-0 ml-2 jr-chart-up c-text-s1 text-${increase > 0 ? "success" : "danger"}`} >{ratio ? (Math.floor((Math.abs(increase) * 100)) + "%") : Math.abs(increase)}<i style={{ marginLeft: 3, marginBottom: 4 }} className={`zmdi zmdi-caret-${increase > 0 ? "up" : "down"}`} /></h5> : null}
      </div>
      <div className="jr-line-indi-info w-100">
        <div className={`jr-line-indi ${bgClassName}`} style={{
          height: 6, borderRadius: 3,
          width: width
        }} />
        {!Util.invalid(value)?<span className={`jr-line-indi-count ml-2 c-text-s1 c-text-dark ${spanClassName}`} style={{ minWidth: 35 }}>{ratio ? (Math.floor((Math.abs(value) * 100)) + "%") : value}</span>:null}
      </div>
    </Aux>
  );
};

LineIndicator.propTypes = {
  width: PropTypes.string.isRequired
};

LineIndicator.defaultProps={
  className:'',
  titleClassName:'',
  bgClassName:"bg-light",
  spanClassName: ''
}



const zIndexTop = 9999;

export class WorkProgress extends React.Component {

  constructor(props) {
      super(props);
      this.state = {
          open: false,
          workId:0,
          progress:0
      }
      WorkProgress.current= this;
  }

  getProgress(arg){
      let {workId,url,success} = arg;
      let my = this;
      Request.mute({
        url: url.get,
        data: { workId },
        error:(msg)=>{
          my.close();
          Notification.error(msg);
        },
        success: (r) => {
          if(!my.state.open){
            return;
          }
          let progress =Util.invalid(r.progress) ? r.Progress : r.progress;
          
          if(progress >= 1){
            my.setState({open:false,progress},()=>{
              if(success) success();
            });
          } else{
            my.setState({progress},()=>{
              setTimeout(() => {
                this.getProgress(arg);
              }, 500);
            });
          }
        }
    });
  }

  open(arg) {
    let {workId}=arg;
    this.arg= arg;
    this.setState({ open: true,workId,progress:0,cancel:false },()=>{
      this.getProgress(arg);
    });
  }

  close() {
    this.setState({ open: false,progress:0,cancel:false,workId:0 });
  }

  cancel(){
    let my = this;
    let {workId,url,cancel} = this.arg;
    my.setState({cancel:true},()=>{
      Request.mute({
          url: url.cancel,
          data: { workId },
          success:()=>{
            my.close();
            if(cancel) cancel();
          }
        });
    });
  }

  renderMain() {
    let { progress,cancel } = this.state;
    let value = (progress || 0) * 100;
    return (
        <div className="row no-gutters w-100">
            <div className="col-1 col-md-2 col-xl-3"></div>
            <div className="col-10 col-md-8 col-xl-6">
              <Alert className="alert-addon-card bg-white text-dark shadow-lg mb-0 w-100">
                  <div className="d-flex flex-row justify-content-between align-items-center">
                    <span className="icon-addon alert-addon bg-info text-white">
                        <CircularProgress color="inherit" size={30} thickness={4} />
                    </span>
                    <div className="d-flex flex-row justify-content-start align-items-center c-flex-1">
                          <label className="text-dark c-text-s1">{cancel?"正在取消":"请稍候"}</label>
                          <div className="c-flex-1 ml-3">
                            <ProgressBar color="success" value={value} width="100%" />
                          </div>
                          <div className="d-flex justify-content-center align-items-center" style={{width:"60px"}}>
                            <font className="c-text-s1 c-text-sm-s2">{`${value}%`}</font>
                          </div>
                          <div className="d-flex flex-row justify-content-end align-items-center">
                            <Button disabled={cancel} color="grey" shadow={0} size="sm" onClick={()=>{ this.cancel(); }}>取消</Button>
                        </div>
                    </div>
                  </div>
              </Alert>
            </div>
            <div className="col-1 col-md-2 col-xl-3"></div>
        </div>)
}

  render() {
      let { open } = this.state;
      let { style } = this.props;
      return (
          <Backdrop
              style={{ zIndex:zIndexTop, backgroundColor: "rgba(0, 0, 0, 0.3)", ...style }}
              open={open}
          >
           {this.renderMain()}
          </Backdrop>
      )
  }
}